import React from "react";
import Markdown from "@irati/ui/src/Markdown";
import { ImportantInfoUl, ImportantInfoLi } from "./styled";
var ImportantInfoList = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b;
    return (React.createElement(ImportantInfoUl, null, data.map(function (e, i) { return (React.createElement(ImportantInfoLi, { key: i },
        React.createElement(Markdown, { source: e }))); })));
};
export default ImportantInfoList;
